import { IRadRepository } from './IRadRepository';
import { injectable, inject } from 'inversify';
import Logger from 'utilities/log';
import { SystemLogModel, SystemLogPayloadFilterModel } from 'models/report/systemLog';
import { PaginationModel, PaginationPayloadModel } from 'models/PaginationModel';
import { ApiRadResponseModel, ApiResponseModel } from 'models/ApiResponseModel';
import { RadWorkTypeBaseModel,  } from 'models/rad/RadWorkTypeBaseModel';
import type BaseApiProvider from 'providers/BaseApiProvider';
import { RadFlowBaseModel } from 'models/rad/RadFlowBaseModel';
import { RadResultBaseModel } from 'models/rad/RadResultBaseModel';
import { RadAudiencePayloadModel, RadTarafHesabBaseModel, RadTarafHesabPayloadModel } from 'models/rad/RadTarafHesabModel';
import { RadWorkDesignerFieldListModel, RadWorkDesignerFieldModel, RadWorkDesignerImgFieldModel } from 'models/rad/RadWorkDesignerFieldModel';
import { FlowFormBuilderDesignPayloadListModel } from 'models/flow/FlowFormBuilderDesignModel';
import { RadpeygirBaseInfoModel } from 'models/rad/RadWorkBaseModel';
import { RadWorkFinancialModel } from 'models/rad/RadWorkFinancialModel';
import { RadWorkFinancialInfo } from 'models/rad/RadWorkFinancialInfo';
import { RadUnDoneWorkFilterModel, RadUnDoneWorkModel, RadUnDoneWorkPayloadModel } from 'models/rad/RadUnDoneWorkModel';
import { RadWorkAttachmentModel } from 'models/rad/RadWorkAttachmentModel';
import { RadFilePathModel } from 'models/rad/RadFilePathModel';

@injectable()
class RadRepository implements IRadRepository {

    @inject(Symbol.for("BaseApiProvider_2080")) private _provider?: BaseApiProvider;


//#region  Action
    public async RadSaveTarafHesabInfo(params: RadTarafHesabPayloadModel): Promise<ApiRadResponseModel | null> {
        try {
            const url = `File/InsertOrUpdateAccountInfo`;
            const response = await this._provider!.post(url, params);
            const res = ApiRadResponseModel.fromJson(response);
            res.data = response["data"];
            return res;
        } catch (error) {
           Logger.event('API_RESPONSE_ERROR', `Failed to SaveTarafHesab: ${error}`);
                      throw new Error(`Failed to SaveTarafHesab: ${error}`);
        }
    }

    public async RadSaveAudienceInfo(params: RadAudiencePayloadModel): Promise<ApiRadResponseModel | null> {
        try {
            const url = `File/InsertOrUpdateAudienceInfo`;
            const response = await this._provider!.post(url, params);
                const res = ApiRadResponseModel.fromJson(response);
               res.data = response["data"];
                return res;
        } catch (error) {
                alert(error);
            Logger.event('API_RESPONSE_ERROR', `Failed to set account info: ${error}`);
            throw new Error(`Failed to set account info: ${error}`);
        }
    }

    public async RadAppDesignedSaveValues(params: RadWorkDesignerFieldListModel): Promise<ApiRadResponseModel | null> {
        try {
            const url = `Work/FormBuilder/AppDesignedSaveValues`;
            const response = await this._provider!.post(url, params);
                const res = ApiRadResponseModel.fromJson(response);
               res.data = response["data"];
                return res;
        } catch (error) {
                alert(error);
            Logger.event('API_RESPONSE_ERROR', `Failed to set account info: ${error}`);
            throw new Error(`Failed to set account info: ${error}`);
        }
    }
    
        public async RadRebuildPeygirInfo(peygirId: number): Promise<ApiResponseModel | null> {
            try {
                const url = `RebuildWork`;
                const formData = new FormData();
                formData.append('peygir_id', peygirId.toString());
                const response = await this._provider!.postForm(url, formData);
                const res = ApiResponseModel.fromJson(response);
                res.data = response["data"];
                return res;
            } catch (error) {
                Logger.event('API_RESPONSE_ERROR', `Failed to RadRebuildAndDeletePeygirInfo: ${error}`);
                throw new Error(`Failed to RadRebuildAndDeletePeygirInfo: ${error}`);
            }
        }
        public async RadDeletePeygirInfo(peygirId: number): Promise<ApiResponseModel | null> {
            try {
                const url = `DeleteWork`;
                const formData = new FormData();
                formData.append('peygir_id', peygirId.toString());
                const response = await this._provider!.postForm(url, formData);
                const res = ApiResponseModel.fromJson(response);
                res.data = response["data"];
                return res;
            } catch (error) {
                Logger.event('API_RESPONSE_ERROR', `Failed to RadRebuildAndDeletePeygirInfo: ${error}`);
                throw new Error(`Failed to RadRebuildAndDeletePeygirInfo: ${error}`);
            }
        }
//#endregion Action

        public async RadWorkTypeBaseInfo(Id: number): Promise<RadWorkTypeBaseModel| null> {
            try {
                const url = `Flow/Info/FlowWorkTypeBaseInfo`;
                const formData = new FormData();
                formData.append('flowWorkId', Id.toString());
                const response = await this._provider!.postForm(url, formData);
                // const res = ApiResponseModel.fromJson(response);
                if (!response.status) {
                    Logger.event('API_RESPONSE_ERROR', response.error || 'Failed to get WorkTypeBaseInfo');
                    return null;
                }
            return RadWorkTypeBaseModel.fromJson(response.data.WorkTypeInfo);
            } catch (error) {
                Logger.event('API_RESPONSE_ERROR', `Failed to get WorkTypeBaseInfo: ${error}`);
                throw new Error(`Failed to get WorkTypeBaseInfo: ${error}`);
            }
        }
        public async RadFlowBaseInfo(Id: number): Promise<RadFlowBaseModel| null> {
          try {
              const url = `Flow/Info/FlowBaseInfo`;
              const formData = new FormData();
              formData.append('Id', Id.toString());
              const response = await this._provider!.postForm(url, formData);
              if (!response.status) {
                  Logger.event('API_RESPONSE_ERROR', response.error || 'Failed to get FlowBaseInfo');
                  return null;
              }
          return RadFlowBaseModel.fromJson(response.data.FlowInfo);
          } catch (error) {
              Logger.event('API_RESPONSE_ERROR', `Failed to get FlowBaseInfo: ${error}`);
              throw new Error(`Failed to get FlowBaseInfo: ${error}`);
          }
      }
 public async GetAllRadFlowSelectList(parentId: number): Promise<{
        rows: RadFlowBaseModel[];
    } | null> {
        try {
            const url = `Flow/Info/LoadLazyFlowList`;     
             const formData = new FormData();
            formData.append('parentId', parentId.toString());
            formData.append('isAll', "1");
            const response = await this._provider!.postForm(url, formData);
            if (!response.status) {
                Logger.event('API_RESPONSE_ERROR', response.error || 'Failed to get users list');
                return null;
            }
            return {
              rows:response.data.FlowList.map((item: any): RadFlowBaseModel => (item))
            };
        } catch (error) {
            Logger.event('API_RESPONSE_ERROR', `Failed to get RadFlowBaseModel list: ${error}`);
            throw new Error(`Failed to get users list: ${error}`);
        }
    }
    
 public async GetAllRadFlowWorkTypeSelectList(flowId: number): Promise<{
  rows: RadWorkTypeBaseModel[];
} | null> {
  try {
      const url = `/Flow/Info/GetFlowWorkTypeList`;     
       const formData = new FormData();
      formData.append('flowId', flowId.toString());
      const response = await this._provider!.postForm(url, formData);
      if (!response.status) {
          Logger.event('API_RESPONSE_ERROR', response.error || 'Failed to get users list');
          return null;
      }
      return {
        rows:response.data.FlowWorkTypeList.map((item: any): RadWorkTypeBaseModel => (item))
      };
  } catch (error) {
      Logger.event('API_RESPONSE_ERROR', `Failed to get RadWorkTypeBaseModel list: ${error}`);
      throw new Error(`Failed to get users list: ${error}`);
  }
}
public async RadFlowResultBaseInfo(Id: number): Promise<RadResultBaseModel| null> {
    try {
        const url = `Flow/Info/FlowResultBaseInfo`;
        const formData = new FormData();
        formData.append('Id', Id.toString());
        const response = await this._provider!.postForm(url, formData);
        // const res = ApiResponseModel.fromJson(response);
        if (!response.status) {
            Logger.event('API_RESPONSE_ERROR', response.error || 'Failed to get WorkTypeBaseInfo');
            return null;
        }
    return RadResultBaseModel.fromJson(response.data.ResultInfo);
    } catch (error) {
        Logger.event('API_RESPONSE_ERROR', `Failed to get WorkTypeBaseInfo: ${error}`);
        throw new Error(`Failed to get WorkTypeBaseInfo: ${error}`);
    }
}

public async GetAllRadFlowResultSelectList(flowWorkTypeId: number): Promise<{
    rows: RadResultBaseModel[];
  } | null> {
    try {
        const url = `/Flow/Info/GetFlowResultListByFlowWorkId`;     
         const formData = new FormData();
        formData.append('Id', flowWorkTypeId.toString());
        const response = await this._provider!.postForm(url, formData);
        if (!response.status) {
            Logger.event('API_RESPONSE_ERROR', response.error || 'Failed to get users list');
            return null;
        }
        return {
          rows:response.data.FlowResultList.map((item: any): RadResultBaseModel => (item))
        };
    } catch (error) {
        Logger.event('API_RESPONSE_ERROR', `Failed to get RadWorkTypeBaseModel list: ${error}`);
        throw new Error(`Failed to get users list: ${error}`);
    }
  }

public async GetAllRadDesignerAllFieldList(flowWorkTypeId: number): Promise<{
    rows: RadWorkDesignerFieldModel[];
  } | null> {
    try {
        const url = `/Work/FormBuilder/DesignerAllFieldList`;     
         const formData = new FormData();
        formData.append('flowWorkTypeId', flowWorkTypeId.toString());
        const response = await this._provider!.postForm(url, formData);
        if (!response.status) {
            Logger.event('API_RESPONSE_ERROR', response.error || 'Failed to get users list');
            return null;
        }
        return {
          rows:response.data.rows.map((item: any): RadResultBaseModel => (item))
        };
    } catch (error) {
        Logger.event('API_RESPONSE_ERROR', `Failed to get RadWorkTypeBaseModel list: ${error}`);
        throw new Error(`Failed to get users list: ${error}`);
    }
  }

public async AppDesignedFormFieldList(flowWorkTypeId: number,radPeygirId: number): Promise<{
    rows: RadWorkDesignerFieldModel[];
  } | null> {
    try {
        const url = `/Work/FormBuilder/AppDesignedFormFieldList`;     
         const formData = new FormData();
        formData.append('peygir_id', radPeygirId.toString());
        formData.append('flowWorkTypeId', flowWorkTypeId.toString());
        const response = await this._provider!.postForm(url, formData);
        if (!response.status) {
            Logger.event('API_RESPONSE_ERROR', response.error || 'Failed to get users list');
            return null;
        }
        return {
          rows:response.data.rows.map((item: any): RadResultBaseModel => (item))
        };
    } catch (error) {
        Logger.event('API_RESPONSE_ERROR', `Failed to get RadWorkTypeBaseModel list: ${error}`);
        throw new Error(`Failed to get users list: ${error}`);
    }
  }

    public async RadInsertPeygirWithFormBuilderValues(params: FlowFormBuilderDesignPayloadListModel): Promise<ApiRadResponseModel | null> {
        try {
                    const url = `ShayaPanel/Action/InsertPeygirWithFormBuilderValues`;     
            const response = await this._provider!.post(url, params);
            const res = ApiRadResponseModel.fromJson(response);
            res.data = response["data"];
            return res;
        } catch (error) {
           Logger.event('API_RESPONSE_ERROR', `Failed to SaveTarafHesab: ${error}`);
                      throw new Error(`Failed to SaveTarafHesab: ${error}`);
        }
    }
    public async RadPanelConfirmPeygir(peygirId:string,resultId:number, File1?: File,Description?:string): Promise<ApiRadResponseModel | null> {
        try {
                    const url = `ShayaPanel/Action/PanelConfirmPeygir`;     
         const formData = new FormData();
        formData.append('peygirId', peygirId.toString());
        formData.append('resultId', resultId.toString());
        formData.append('Description', Description??"");
        if(File1!)
        formData.append('File1', File1);
        const response = await this._provider!.postForm(url, formData);
            const res = ApiRadResponseModel.fromJson(response);
            res.data = response["data"];
            return res;
        } catch (error) {
           Logger.event('API_RESPONSE_ERROR', `Failed to SaveTarafHesab: ${error}`);
                      throw new Error(`Failed to SaveTarafHesab: ${error}`);
        }
    }
    public async RadPanelDeletePeygir(peygirId:string): Promise<ApiRadResponseModel | null> {
        try {
         const url = `ShayaPanel/Action/PanelDeletePeygir`;     
         const formData = new FormData();
        formData.append('peygirId', peygirId.toString());
        const response = await this._provider!.postForm(url, formData);
            const res = ApiRadResponseModel.fromJson(response);
            res.data = response["data"];
            return res;
        } catch (error) {
           Logger.event('API_RESPONSE_ERROR', `Failed to SaveTarafHesab: ${error}`);
                      throw new Error(`Failed to SaveTarafHesab: ${error}`);
        }
    }
public async RadPanelDesignedSaveImgs(
  peygirId: string,
  imgItems: RadWorkDesignerImgFieldModel[],
): Promise<ApiRadResponseModel | null> {
  try {
    const url = `ShayaPanel/Action/PanelDesignedSaveImg`;

    const formData = new FormData();
    formData.append("peygir_id", peygirId.toString());
    imgItems.forEach(item => {
      if (item.fimg) {
        formData.append(item.colname, item.fimg, item.colname);
      }
    });

    const response = await this._provider!.postForm(url, formData);

    const res = ApiRadResponseModel.fromJson(response);
    res.data = response["data"];
    return res;
  } catch (error) {
    Logger.event(
      "API_RESPONSE_ERROR",
      `Failed to RadPanelConfirmPeygirMulti: ${error}`
    );
    throw new Error(`Failed to RadPanelConfirmPeygirMulti: ${error}`);
  }
}
public async RadGetSelectedWorkList(peygirId: string): Promise<{
    rows: RadpeygirBaseInfoModel[];
  } | null> {
    try {
        const url = `/ShayaPanel/Info/SelectedWorkList`;     
         const formData = new FormData();
        formData.append('peygirId', peygirId.toString());
        const response = await this._provider!.postForm(url, formData);
        if (!response.status) {
            Logger.event('API_RESPONSE_ERROR', response.error || 'Failed to get GetSelectedWorkList list');
            return null;
        }
        return {
          rows:response.data.rows.map((item: any): RadResultBaseModel => (item))
        };
    } catch (error) {
        Logger.event('API_RESPONSE_ERROR', `Failed to get GetSelectedWorkList list: ${error}`);
        throw new Error(`Failed to get GetSelectedWorkList list: ${error}`);
    }
  }
public async RadGetFinancialItemsList(peygirId: string): Promise<{
    rows: RadWorkFinancialModel[];
  } | null> {
    try {
        const url = `/ShayaPanel/Info/GetFinancialItemsList`;     
         const formData = new FormData();
        formData.append('peygirId', peygirId.toString());
        const response = await this._provider!.postForm(url, formData);
        if (!response.status) {
            Logger.event('API_RESPONSE_ERROR', response.error || 'Failed to get GetFinancialItemsList list');
            return null;
        }
        return {
          rows:response.data.rows.map((item: any): RadResultBaseModel => (item))
        };
    } catch (error) {
        Logger.event('API_RESPONSE_ERROR', `Failed to get GetFinancialItemsList list: ${error}`);
        throw new Error(`Failed to get GetFinancialItemsList list: ${error}`);
    }
  }
        public async RadGetWorkTotalFinancialinfo(peygirId: string): Promise<RadWorkFinancialInfo| null> {
          try {
              const url = `ShayaPanel/Info/GetWorkTotalFinancialinfo`;
              const formData = new FormData();
              formData.append('peygirId', peygirId.toString());
              const response = await this._provider!.postForm(url, formData);
              if (!response.status) {
                  Logger.event('API_RESPONSE_ERROR', response.error || 'Failed to get FlowBaseInfo');
                  return null;
              }
          return RadWorkFinancialInfo.fromJson(response.data.peygirInfo);
          } catch (error) {
              Logger.event('API_RESPONSE_ERROR', `Failed to get FlowBaseInfo: ${error}`);
              throw new Error(`Failed to get FlowBaseInfo: ${error}`);
          }
      }
      public async RadGetUnDoneWorkList(params:RadUnDoneWorkPayloadModel): Promise<{
    rows: RadUnDoneWorkModel[];
     pagination: PaginationModel;
  } | null> {
    try {
  const url = `/ShayaPanel/Info/GetUnDoneWorkList`;
            const response = await this._provider!.post(url, params);
        if (!response.status) {
            Logger.event('API_RESPONSE_ERROR', response.error || 'Failed to get users list');
            return null;
        }
        return {
          rows: response.data?.rows?.map((item: any): RadUnDoneWorkModel => item) ?? [],
           pagination: PaginationModel.fromJson(response["data"])
        };
    } catch (error) {
        Logger.event('API_RESPONSE_ERROR', `Failed to get RadWorkTypeBaseModel list: ${error}`);
        throw new Error(`Failed to get users list: ${error}`);
    }
  }
public async RadGetUnDoneWorkCount(params: RadUnDoneWorkPayloadModel): Promise<number | null> {
  try {
    const url = `/ShayaPanel/Info/GetUnDoneWorkCount`;
    const response = await this._provider!.post(url, params);

    return response.data?.totalcount ?? 0;
  } catch (error) {
    Logger.event('API_RESPONSE_ERROR', `Failed to get count: ${error}`);
    throw new Error(`Failed to get count: ${error}`);
  }
}
public async RadAttachmentsCount(peygirId: string): Promise<number | null> {
  try {
    const url = `/ShayaPanel/Info/AttachmentsCountInfo`;
    const formData = new FormData();
      formData.append('peygirId', peygirId.toString());
     const response = await this._provider!.postForm(url, formData);
    return response.data?.fileCount ?? 0;
  } catch (error) {
    Logger.event('API_RESPONSE_ERROR', `Failed to get count: ${error}`);
    throw new Error(`Failed to get count: ${error}`);
  }
}
public async RadGetAttachmentsList(peygirId: string): Promise<{
    rows: RadWorkAttachmentModel[];
  } | null> {
    try {
        const url = `/ShayaPanel/Info/GetAttachmentsList`;     
         const formData = new FormData();
        formData.append('peygirId', peygirId.toString());
        const response = await this._provider!.postForm(url, formData);
        if (!response.status) {
            Logger.event('API_RESPONSE_ERROR', response.error || 'Failed to get GetFinancialItemsList list');
            return null;
        }
        return {
          rows:response.data.rows.map((item: any): RadResultBaseModel => (item))
        };
    } catch (error) {
        Logger.event('API_RESPONSE_ERROR', `Failed to get GetFinancialItemsList list: ${error}`);
        throw new Error(`Failed to get GetFinancialItemsList list: ${error}`);
    }
  }   
  public async RadGetFilePathInfo(Id: number): Promise<RadFilePathModel| null> {
            try {
                const url = `GetFilePath`;
                const formData = new FormData();
                formData.append('Id', Id.toString());
                const response = await this._provider!.postForm(url, formData);
                if (!response.status) {
                    Logger.event('API_RESPONSE_ERROR', response.error || 'Failed to get WorkTypeBaseInfo');
                    return null;
                }
            return RadFilePathModel.fromJson(response.data);
            } catch (error) {
                Logger.event('API_RESPONSE_ERROR', `Failed to get WorkTypeBaseInfo: ${error}`);
                throw new Error(`Failed to get FilePath: ${error}`);
            }
        }
}


export default RadRepository;
